export const useMobileDetection = () => {
    return {
        isAndroid: isAndroid(),
        isIOS: isIOS(),
        isMobile: isMobile(),
    }
}

export function isIOS() {
    return isIPhone() || isIPad()
}

export function isMobile() {
    return isIOS() || isAndroid()
}

function isAndroid() {
    return navigator.userAgent.toLowerCase().includes('android')
}

function isIPhone() {
    return /iPhone|iPod/.test(navigator.platform)
}

function isIPad() {
    // iPads on iPadOS may return "MacIntel", so check for touch capabilities.
    return /iPad/.test(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}
